import { render } from "./TasksGroupedListView.vue?vue&type=template&id=1c39aed4"
import script from "./TasksGroupedListView.vue?vue&type=script&lang=js"
export * from "./TasksGroupedListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__